import LayoutDashboard from "layouts/layout-dashboard-collapse";
import React, { useState } from "react";
import { useDailyTransaction } from "./DailyTransactionContext";
import { Bar } from "react-chartjs-2";
import Swal from "sweetalert2";
import DailySummaryCard from "../History/DailySummaryCard";
import { formatPrice } from "utils/utils";
import SummaryTotals from "../components/SummaryTotals";

const DailyReportPOS = () => {
  const { summary, summaryData, Pagination, setDateRange, refetchTransaction } =
    useDailyTransaction();

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // ✅ Inisialisasi default date range (1 minggu terakhir)
  // useEffect(() => {
  //   const now = new Date();
  //   const sevenDaysAgo = new Date();
  //   sevenDaysAgo.setDate(now.getDate() - 7);

  //   const formattedStart = sevenDaysAgo.toISOString().split("T")[0];
  //   const formattedEnd = now.toISOString().split("T")[0];

  //   // setStartDate(formattedStart);
  //   // setEndDate(formattedEnd);
  //   // setDateRange(formattedStart, formattedEnd);
  //   // refetchTransaction(); // Trigger fetch pertama
  // }, [setDateRange, refetchTransaction]);

  const handleFilter = () => {
    if (!startDate || !endDate) {
      Swal.fire({
        icon: "warning",
        title: "Tanggal belum lengkap",
        text: "Harap pilih rentang tanggal (start dan end)",
        toast: true,
        position: "top-end",
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }

    setDateRange(startDate, endDate);
    refetchTransaction();
  };

  return (
    <LayoutDashboard>
      <div className="container-fluid mt-3">
        <DailySummaryCard />

        {/* Summary Totals */}
        <SummaryTotals summaryData={summaryData} containerClass="row row-cards my-2" />

        {summary?.length > 0 && (
          <div className="mb-4">
            <h5 className="mb-3">Graph Summary</h5>
            <p className="text-muted">Data yang tampil adalah 1 hari ini.</p>
            <Bar
              className="bg-light p-1"
              data={{
                labels: summary.map((item) => item.menu),
                datasets: [
                  {
                    label: "Total Penjualan",
                    data: summary.map((item) => item.total_quantity),
                    backgroundColor: "rgba(75,192,192,0.6)",
                  },
                ],
              }}
              options={{
                responsive: true,
                plugins: {
                  legend: { display: true },
                  tooltip: {
                    callbacks: {
                      label: function (context) {
                        return `${context.parsed.y.toLocaleString()}`;
                      },
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                    ticks: {
                      callback: function (value) {
                        return `${value.toLocaleString()}`;
                      },
                    },
                  },
                },
              }}
            />
          </div>
        )}
      </div>
      <div className="container-fluid mt-5">
        <h3>Daily Report</h3>

        <div className="table-container">
          <div className="search-container mb-3 d-flex justify-content-between align-items-center">
            <SearchInput />
            <div className="d-flex align-items-center gap-2">
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
              <button className="btn btn-primary" onClick={handleFilter}>
                Filter
              </button>
            </div>
          </div>

          <div className="table">
            <table className="table table-hover table-vcenter table-sm">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Menu</th>
                  <th>Quantity</th>
                  <th>Amount Before Tax</th>
                  <th>Tax Amount</th>
                  <th>Amount After Tax</th>
                </tr>
              </thead>
              <tbody>
                {/* print json */}
                {/* <pre>{JSON.stringify(summary, null, 2)}</pre> */}
                {summary?.length > 0 ? (
                  summary.map((item, index) => (
                    <tr key={item.menu || index}>
                      <td>{index + 1}</td>
                      <td>{item.menu}</td>
                      <td>{item.total_quantity}</td>
                      <td>{formatPrice(Number(item.total_amount_before_tax))}</td>
                      <td>{formatPrice(Number(item.total_tax_amount))}</td>
                      <td>{formatPrice(Number(item.total_amount_after_tax))}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No summary data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="mt-4 text-center">{Pagination}</div>
        </div>

      </div>

      {/* <TransactionProvider>
        <POS_History />
      </TransactionProvider> */}
    </LayoutDashboard>
  );
};

export default DailyReportPOS;

const SearchInput = () => {
  const [search, setSearch] = useState("");
  const handleSearch = (e) => {
    if (e.key === "Enter") {
      // Future implementation if needed
    }
  };
  return (
    <div className="input-icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleSearch}
      />
      <span className="input-icon-addon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-search"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="10" cy="10" r="7" />
          <line x1="21" y1="21" x2="15" y2="15" />
        </svg>
      </span>
    </div>
  );
};
